import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FileSystemProjectStatus } from 'shared/domains/apollo/generated/types';
export const getProjectStatusLabels = () => ({
    [FileSystemProjectStatus.Backlog]: t({
        message: 'Backlog',
        comment: 'Project status - Backlog',
    }),
    [FileSystemProjectStatus.Cancelled]: t({
        message: 'Cancelled',
        comment: 'Project status - Cancelled',
    }),
    [FileSystemProjectStatus.Completed]: t({
        message: 'Completed',
        comment: 'Project status - Completed',
    }),
    [FileSystemProjectStatus.InProgress]: t({
        message: 'In progress',
        comment: 'Project status - In progress',
    }),
    [FileSystemProjectStatus.OnHold]: t({
        message: 'On hold',
        comment: 'Project status - On hold',
    }),
});
export const getProjectStatusIcon = (status) => {
    const icons = {
        [FileSystemProjectStatus.Backlog]: (<Falcon icon="circle-dashed" $color="swatches.gray.500" sourceConfig={{ family: 'classic', style: 'solid' }}/>),
        [FileSystemProjectStatus.Cancelled]: (<Falcon icon="circle-xmark" $color="swatches.gray.500" sourceConfig={{ family: 'classic', style: 'solid' }}/>),
        [FileSystemProjectStatus.Completed]: (<Falcon icon="circle-check" $color="swatches.green.500" sourceConfig={{ family: 'classic', style: 'solid' }}/>),
        [FileSystemProjectStatus.InProgress]: (<Falcon icon="circle-half-stroke" $color="swatches.blue.500" sourceConfig={{ family: 'classic', style: 'solid' }}/>),
        [FileSystemProjectStatus.OnHold]: (<Falcon icon="circle-pause" $color="swatches.orange.500" sourceConfig={{ family: 'classic', style: 'solid' }}/>),
    };
    return icons[status];
};
export const getProjectStatusAppearance = (contractTerm) => {
    const appearances = {
        [FileSystemProjectStatus.Backlog]: 'secondary',
        [FileSystemProjectStatus.InProgress]: 'info',
        [FileSystemProjectStatus.OnHold]: 'warning',
        [FileSystemProjectStatus.Completed]: 'success',
        [FileSystemProjectStatus.Cancelled]: 'danger',
    };
    return appearances[contractTerm];
};
